module.exports = __webpack_public_path__ + "img/minecraft_username.454d838f.png";